import React, { useContext, useEffect, useState } from "react";
import Head from "next/head";
import { Header } from "./Header/web";
import "./styles.less";
import { useFilters } from "shared-components/Components/Filters/Filters.hook";
import { ListingStructDataJson } from "shared-components/ViewFragments/SearchPage/ListingStructDataJson";
import { SearchResultsPagination } from "shared-components/ViewFragments/SearchResults/Content/SearchResultsCards/SearchResultsPagination/web";
import { Listings } from "./Listings";
import { noIndexDelListado } from "./noIndexDelListado";
import { Button } from "shared-components/Components/Buttons/web";
import dynamic from "next/dynamic";
import { ButtonMapToggle } from "shared-components/ViewFragments/SearchResults/Content/MapButton/web";
import { Order } from "shared-components/Components/Filters/Order/web";
import { SearchResultDisplay } from "shared-components/ViewFragments/SearchResults/Content/SearchResultsCards/SearchResultsPagination/ResultDisplay/web";
import { useWindowSize } from "shared-components/GlobalHooks/useWindowSize";
import { BreadCrumbs } from "shared-components/Components/SEO/BreadCrumbs/web";
import { H1 } from "shared-components/Components/SEO/H1/web";
import cookie from "js-cookie";
import { useUser } from "shared-components/Components/User/User.hook";
import { Footer } from "shared-components/ViewFragments/Footer/web";
import { PicHomeFooter } from "shared-components/ViewFragments/Footer/PicHomeFooter/web";
import { MapSearch } from "src/Components/MapSearch/web";
import { LocationTagHolder } from "shared-components/Components/Filters/KeywordLocation/LocationTagsHolder";
import { FilterBar } from "./FilterBar/web";
import { FiltersIcon } from "shared-components/Components/CustomIcons/FiltersIcon/web";
import TopBarFilters from "shared-components/ViewFragments/SearchResults/Sider/TopBarFilters/web";
import { ADS_NAME } from "src/constants/ads";
import useListingTags from "src/hooks/listingTags/useListingTags";
import { useRoutesContext } from "src/contexts/RoutesContext";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { useSearchResultsFilters } from "shared-components/ViewFragments/SearchResults/Sider/Filters/SearchResultsFilters.hook";
import { ModalConsulta } from "shared-components/Components/Property/InformationRequest/LeadButtons/FormButton/ModalConsulta";
import { useContactModal } from "shared-components/Contexts/ContactModal/context";
import { useIsAuthModalShowing } from "shared-components/GlobalHooks/useIsAuthModalShowing";
import { TrendingSearches } from "src/Components/TrendingSearches/web";
import { CitationsResults } from "shared-components/ViewFragments/SearchResults/Content/CitationsResults/web";
import NpsSurveyCard from "shared-components/Components/NpsSurveyCard";
import { BannerPuntaDelEste } from "shared-components/Components/Banners/BannerPuntaDelEste/web";
import { shouldShowPuntaDelEsteBanner } from "shared-components/Components/Banners/BannerPuntaDelEste/shouldShow";



const SiderBar = dynamic(() => import(/* webpackChunkName: "SiderBar" */ "./SiderBar"), {
	ssr: false,
	loading: () => <div className="search-filters">

	</div>,
});

const IcBuscaPorTi = dynamic(() => import("shared-components/Components/PopUps/IcBuscaPorTi/web"), {
	ssr: false,
	loading: () => <div className="search-filters"></div>,
});

export const SearchPageLayout_v3 = ({ fetchResult }) => {
	const { filters, filtersTags, showFilter } = useFilters();
    const { changeFiltersAndUpdateURL } = useSearchResultsFilters();
	const { setListingTags } = useListingTags();
    const { isVisible, modalData, closeContactModal } = useContactModal();
    const { isAuthModalShowing } = useIsAuthModalShowing();
	const { user } = useUser();
	const {country_code, site_name } = useContext(ConfigStateContext)
	const RoutesContext = useRoutesContext();
	const showPuntaDelEsteBanner = shouldShowPuntaDelEsteBanner({
		country_code,
		filters,
		filtersTags,
	});
	const screen = useWindowSize();
	const [map, setMap] = useState<boolean>(false);
	const [error, setError] = useState(false);
	const [sider, setSider] = useState(false);
	const [modal, setModal] = useState(false);
	const idealFilters = ["operation_type_id", "property_type_id", "maxPrice", "bedrooms"];
	const data = fetchResult;
	const loading = RoutesContext.routes.loading
	const noIndex = noIndexDelListado(data, filters);

    useEffect(()=>{
        if(screen.xs && map){
            document.body.classList.add('no-scroll');
        }
        else {
            document.body.classList.remove('no-scroll');
        }
    },[screen.xs, map])

	useEffect(() => {
		const dataTags = fetchResult?.searchFast?.data.map((property) => (
			{
				id: property.id,
				seaDistanceName: property.seaDistanceName,
				isProject: property.isProject,
				highlight: property.highlight,
				owner: property.owner,
				isExternal: property.isExternal,
				tour3d: property.tour3d,
				link: property.link,
				legacy_propID: property.legacy_propID,
				title: property.title,
				tag: property.tag
			}
		))

		setListingTags(dataTags)
		RoutesContext.setRoutes({ loading: false })
	}, [data]);

	useEffect(() => {
		const cookieModal = cookie.get("modalBuscaPorTi");
		if (!modal && typeof cookieModal === "undefined") {
			const filtersKeys = Object.keys(filters);
			const hasIdealFilters = idealFilters.every(elem => filtersKeys.includes(elem));
			if (filters.page >= 2 && hasIdealFilters) {
				let showModal = true;
				if (user.data.me && user.data.me.searchAlerts) {
					(user.data.me.searchAlerts ?? []).map(search => {
						const searchStringify = JSON.stringify(search.filters);
						const filtersAsArray = Object.entries(filters).filter(
							filter =>
								filter[0] !== "page" &&
								filter[0] !== "order" &&
								filter[0] !== "map_bounds"
						);
						const finalFiltersObject = Object.fromEntries(filtersAsArray);
						const filtersStringify = JSON.stringify(finalFiltersObject);
						if (showModal !== true) {
							if (searchStringify === filtersStringify) showModal = false;
							else showModal = true;
						}
					});
				}
				setModal(showModal);
			}
		}
	}, [filters, user]);

    const openSider = () => {
        setSider(true)
        document.body.classList.add("no-scroll")
    }
    const closeSider = () => {
        setSider(false)
        document.body.classList.remove("no-scroll")
    }

    const toggleSider = () => {
        if (sider) {
            closeSider()
        } else {
            openSider()
        }
    }

	const handleClose = () => {
		cookie.set("modalBuscaPorTi", "Si", { expires: 7 });
	};

    const affixedMobileButtons = (
        <div className="search-results-affix-bar">
            <div className="bar" style={{ marginBottom: 16 }}>
                <div style={{ flexGrow: 1, maxWidth: 'calc(100% - 55px)' }}>
                    <LocationTagHolder
                        changeFilters={changeFiltersAndUpdateURL}
                        filtersTags={filtersTags}
                        show={showFilter.location}
                    />
                </div>
                <ButtonMapToggle map={map} setMap={setMap} small={true} />
            </div>

            <FilterBar toggleFilters={() => { toggleSider() }} />            
        </div>
    )

    const topContent = (
        <>
            {showPuntaDelEsteBanner && <BannerPuntaDelEste />}
            <div className="topContent-wrap">
                <div className="search-result-text-info">
                    <H1 />
                    {!screen.xs && <BreadCrumbs />}
                    {!map && data?.searchFast?.paginatorInfo && (
                        <SearchResultDisplay
                            loading={loading}
                            error={error}
                            paginatorInfo={data?.searchFast?.paginatorInfo}
                        />
                    )}
                </div>

                {screen.lg &&
                    <div className="bar">
                        <Order />
                        <ButtonMapToggle map={map} setMap={setMap} />
                    </div>
                }
                {(!screen.lg && !map) && <Order textVersion={true} />}
            </div>
        </>
    );

    return <>
        <Header showSearchBar isSticky={!screen.lg && !sider} />

        {noIndex && <>
            <Head>
                <meta name="robots" content="noindex, follow" />
            </Head>
        </>}
        {data?.searchFast?.data && data?.searchFast?.data?.length > 0 &&
            <ListingStructDataJson listings={data?.searchFast?.data} />
        }

        {screen.lg && <TopBarFilters />}
        {!screen.lg && (screen.md || screen.sm || screen.xs) && affixedMobileButtons}
        {sider &&
            <SiderBar
                sider={sider}
                setSider={toggleSider}
                changeFilters={changeFiltersAndUpdateURL}
                filters={filters}
                filtersTags={filtersTags}
                updateURL={()=>{}}
                showFilter={showFilter}
            />
        }

        {!map || (map && screen.lg) ?
            <div className={!map? "search-page-container" : "search-page-container-map search-page-container"}>            
                <div className="search-results-content" style={
                    map && screen.lg ? {
                        position: 'sticky',
                        top: '96px'
                    } : {}
                } >
                    {topContent}

                    {!map ? (
                        <>
                            <Listings data={data} loading={loading} error={error} showExpenses={false} />
                            <SearchResultsPagination
                                error={error}
                                loading={loading}
                                paginatorInfo={data?.searchFast?.paginatorInfo}
                            />
                        {(country_code === "CO"  || country_code === "UY") && filters?.projects !== true && (
                            <TrendingSearches />
                        )}
                            <CitationsResults placement="footer" />
                        </>
                    ) : null }
                </div>
            </div>
            : null
        }

        {/* <SearchResultsMap /> <--- mapa previo */}
        {map
            ? <MapSearch />
            : null
        }

        {/*Modal de consulta*/}
        {isVisible || modalData ? (
            <ModalConsulta
                modal={isVisible}
                closeModal={closeContactModal}
                onSuccess={closeContactModal}
                defaultMessage={modalData.defaultMessage}
                owner={modalData.owner}
                id={modalData.id}
                isProject={modalData.isProject}
                projectId={modalData.projectId}
                source={modalData.source}
                propertyLink={modalData.propertyLink}
                isAuthModalShowing={isAuthModalShowing}
            />
        ) : null}

        {/* @TODO - sacar antd y refactor estos 3 componentes
        */}
        {modal && country_code !== 'CO' && <IcBuscaPorTi onClose={handleClose} showButtons />}
        {<NpsSurveyCard site_name={site_name} country_code={country_code} />}
        {!map && <Footer />}
        {!map && <PicHomeFooter />}
    </>
}
